import axios from "axios";
import React, { useState, useEffect } from "react";
import useDidMountEffect from "../../utils/useDidMountEffect";
import { useToasts } from "react-toast-notifications";
import PChangePassword from "../../common/PChangePassword";

import "./settings.css";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Divider,
    useMediaQuery,
} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { ROLES } from "../../utils/constants";
import DefaultPUWidget from "../../Widgets/PU/Default";
import DefaultWidget from "../../Widgets/SU/Default";
import PageHeader from "../../common/PageHeader";
import { useHistory } from "react-router";
import { setAlert } from "../../../redux/actions";
import { useDispatch } from "react-redux";

const AdvancedSettings = () => {
    const history = useHistory();
    const isMobile = useMediaQuery("(max-width: 899px)");
    const { addToast } = useToasts();
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);
    const [user, setUser] = useState({});
    const [state, setState] = useState({
        subscription_price_val: false,
        new_private_message: false,
        new_referral: false,
    });

    const [isDeleting, setIsDeleting] = useState(false);
    const [isCheckingSubsription, setIsCheckingSubsription] = useState(false);

    const handleUpdate = async (payload) => {
        await axios
            .patch(`/api/creators/${user.creator.id}`, {
                ...payload,
            })
            .then((response) => {
                addToast("Update successful", {
                    appearance: "success",
                    autoDismiss: true,
                });
            })
            .catch((error) => {
                addToast("Unable to process request", {
                    appearance: "error",
                    autoDismiss: true,
                });
            });
    };

    useDidMountEffect(() => {
        fillForm();
    }, [user]);

    const getUserInformation = async () => {
        const userId = localStorage.getItem("loggedin_user");

        if (!userId) {
            window.location = "/login";
        }

        setIsLoading(true);
        await axios
            .get(`/api/users/${userId}`)
            .then((response) => {
                setUser(response.data);
                localStorage.setItem("user", JSON.stringify(response.data));
            })
            .catch((error) => {
                console.log({ error });
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const fillForm = () => {
        let obj = {};
        Object.keys(state).forEach((key) => {
            if (user.creator && user.creator[key]) {
                obj[key] = user.creator[key];
                console.log({ [key]: user.creator[key] });
            }
        });

        setState(obj);
    };

    useEffect(() => {
        getUserInformation();
    }, []);

    const handleSubscriptionPriceVal = () => {
        setState({
            ...state,
            subscription_price_val: !state.subscription_price_val,
        });
        handleUpdate({ subscription_price_val: !state.subscription_price_val });
    };

    const handleNewPrivateMessage = () => {
        setState({
            ...state,
            new_private_message: !state.new_private_message,
        });
        handleUpdate({ new_private_message: !state.new_private_message });
    };

    const handleNewReferral = () => {
        setState({
            ...state,
            new_referral: !state.new_referral,
        });
        handleUpdate({ new_referral: !state.new_referral });
    };

    const handleDeleteAccount = async () => {
        setIsDeleting(true);
        await axios
            .delete("/api/users")
            .then((response) => {
                setIsDeleting(false);
                dispatch(
                    setAlert({
                        show: true,
                        type: "success",
                        body: "Account successfully deleted",
                    })
                );
            })
            .catch((error) => {
                console.error(error);
                setIsDeleting(false);

                if (error.response) {
                    if (error.response.status === 422) {
                        const responseData = error.response.data;
                        const firstErrorKey = Object.keys(responseData.errors);
                        dispatch(
                            setAlert({
                                show: true,
                                type: "error",
                                body: responseData.errors[firstErrorKey[0]],
                            })
                        );
                    }
                }

                dispatch(
                    setAlert({
                        show: true,
                        type: "error",
                        body: "Unable to delete account",
                    })
                );
            });
    };

    const checkForActiveSubs = async () => {
        setIsCheckingSubsription(true);
        await axios
            .get("/api/followings/totals", {
                params: {
                    active: true,
                },
            })
            .then((response) => {
                setIsCheckingSubsription(false);
                if (
                    response.data &&
                    response.data.active &&
                    response.data.active > 0
                ) {
                    dispatch(
                        setAlert({
                            show: true,
                            type: "info",
                            body: "Please Unfollow your active subscriptions",
                        })
                    );
                } else {
                    handleDeleteAccount();
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const [noEmails, setNoEmails] = useState(false);
    const [modifyingNotifications, setModifyingNotifications] = useState(false);
    const handleNoEmailsChange = () => {
        setNoEmails((noEmails) => !noEmails);
        updatePpvNotification(!noEmails);
    };

    const updatePpvNotification = async (payload) => {
        setModifyingNotifications(true);
        await axios
            .patch(`/api/users/${user.id}`, {
                no_emails: payload,
            })
            .then((response) => {
                setModifyingNotifications(false);
                dispatch(
                    setAlert({
                        show: true,
                        type: "success",
                        body: "Notification settings updated",
                    })
                );
            })
            .catch((error) => {
                console.error({ error });
                setModifyingNotifications(false);
                dispatch(
                    setAlert({
                        show: true,
                        type: "error",
                        body: "Unable to update notification settings",
                    })
                );
            });
    };

    useEffect(() => {
        setNoEmails(user.no_emails || "");
    }, [user]);

    return (
        <div className="container advanced-settings-container pt-4 mb-4">
            <Grid2 container spacing={!isMobile ? 2 : 0}>
                <Grid2 item md={8}>
                    <PageHeader
                        title="Advanced Settings"
                        onBack={() => history.push("/edit-profile")}
                        backable={true}
                        closable={false}
                    />

                    <div className="panel panel-default">
                        <div className="panel-body">
                            <PChangePassword user={user} showHeader={false} />
                            <Divider />
                            {user.role == ROLES.SU && (
                                <div
                                    className="row"
                                    style={{ marginTop: "15px" }}
                                >
                                    <div className="col-md-12 Chat-wrap">
                                        <span className={"sm"}>
                                            {" "}
                                            Mute all notifications for my
                                            account *except Admin
                                        </span>
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                name="noEmails"
                                                id="noEmails"
                                                checked={noEmails}
                                                onChange={handleNoEmailsChange}
                                                disabled={
                                                    modifyingNotifications
                                                }
                                            />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                            )}

                            {user.role == ROLES.SU ? (
                                <React.Fragment>
                                    <Divider />
                                    <div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                marginTop: "15px",
                                            }}
                                        >
                                            <button
                                                type="submit"
                                                className="theme-btn theme-btn-bordered btn btn-primary"
                                                disabled={
                                                    isDeleting ||
                                                    isCheckingSubsription
                                                }
                                                style={{
                                                    borderRadius: "10px",
                                                }}
                                                onClick={checkForActiveSubs}
                                            >
                                                {isDeleting
                                                    ? "Deleting Account..."
                                                    : "Delete Account"}
                                            </button>
                                        </div>

                                        <div
                                            style={{
                                                textAlign: "center",
                                                marginTop: "10px",
                                                fontSize: "14px",
                                            }}
                                        >
                                            Note: This cannot be undone, and you
                                            must unfollow all your subscriptions
                                        </div>
                                    </div>
                                </React.Fragment>
                            ) : null}
                        </div>
                    </div>
                </Grid2>
                {!isMobile ? (
                    <Grid2 item className="pu-homepage__right" md={4}>
                        {user && user.role == ROLES.PU ? (
                            <DefaultPUWidget />
                        ) : null}
                        {user && user.role == ROLES.SU ? (
                            <DefaultWidget />
                        ) : null}
                    </Grid2>
                ) : null}
            </Grid2>
        </div>
    );
};

export default AdvancedSettings;
